module.exports = __webpack_public_path__ + "static/media/check-box_parent.01e7b92f.svg";